import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import HeadingLines from '../assets/images/heading-lines.svg' 
import { Link } from 'react-router-dom';
function HomeResources({data}) {
  if (!data) {
    return null; // Correct return for better handling
  }
  

  return (
    <> 
    <section className="home-resources">
      <Container>
        <Row>
        <Col md="12">
            <div className="common-header">
              <img src={HeadingLines} alt="" />
              <h2>{data.title}</h2>
            </div>
        </Col>
          <Col sm="12" md="6" className="mb-4 mb-md-0">
            <Link to={data.cards[0].link} title={data.cards[0].title} className="home-resources-box">
                <img className="home-resources-box-img" 
                src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data.cards[0].image}`}
                alt="" />
                <div className='home-resources-box-content'>
                  <h2>{data.cards[0].title}</h2>
                </div>
            </Link>
          </Col>
          <Col sm="12" md="6">
            <Link to={data.cards[1].link} title={data.cards[1].title} className="home-resources-box">
                <img className="home-resources-box-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data.cards[1].image}`} alt="" />
                <div className='home-resources-box-content'>
                  <h2>{data.cards[1].title}</h2>
                </div>
            </Link>
          </Col>
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default HomeResources